<ng-container *ngIf="pillLabel;then nvPill else emDash"></ng-container>
<ng-template #nvPill>
  <nv-pill *ngIf="!gridConfigParams" [color]="color"> {{ pillLabel }} </nv-pill>
  <nv-pill *ngIf="gridConfigParams" [color]="color"> {{ pillLabel }} </nv-pill>
</ng-template>
<ng-template #emDash>
  <div>{{ emptyCell }}</div>
</ng-template>
